import { ControlGroup } from "@blueprintjs/core";
import React from "react";
import { sprintf } from 'sprintf-js';

import { iDef } from "core/util/TypeUtils";
import BaseWidget from "./BaseWidget";
import CssUnitWidget from "./CssUnitWidget";

interface ISpace {
	top: string;
	right: string;
	bottom: string;
	left: string;
}

export default class SpaceWidget extends BaseWidget<ISpace, string> {
	public render() {
		const space = this.fromValue(this.props.value);

		return (
			<ControlGroup fill={true} vertical={true}>
				<CssUnitWidget
					value={space.top}
					onChange={(value) => this.onChange(space, value, "top")}
					readonly={false}
					autofocus={false}
					options={undefined}
					icon="arrow-up"
				/>
				<CssUnitWidget
					value={space.right}
					onChange={(value) => this.onChange(space, value, "right")}
					readonly={false}
					autofocus={false}
					options={undefined}
					icon="arrow-right"
				/>
				<CssUnitWidget
					value={space.bottom}
					onChange={(value) => this.onChange(space, value, "bottom")}
					readonly={false}
					autofocus={false}
					options={undefined}
					icon="arrow-down"
				/>
				<CssUnitWidget
					value={space.left}
					onChange={(value) => this.onChange(space, value, "left")}
					readonly={false}
					autofocus={false}
					options={undefined}
					icon="arrow-left"
				/>
			</ControlGroup>
		);
	}

	protected onChange(space: ISpace, value: string, part: string) {
		const newSpace = {...space, [part]: value};
		this.props.onChange(this.toValue(newSpace));
	}

	protected toValue(space: ISpace): string {
		return sprintf("%s %s %s %s", space.top, space.right, space.bottom, space.left);
	}

	protected fromValue(value: string): ISpace {
		const parts = (iDef(value) ? value : "0px 0px 0px 0px").split(" ");
		return {top: parts[0], right: parts[1], bottom: parts[2], left: parts[3]};
	}
}



// WEBPACK FOOTER //
// ./src/common/form/widgets/SpaceWidget.tsx